import { defineComponent as _defineComponent } from 'vue'
import CategoryProductFacetFilteringDropdown from './CategoryProductFacetFilteringDropdown.vue';
import { computed, nextTick, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryProductFacetFilteringGroup',
  props: {
    visibleFacets: null,
    facetGroupName: null,
    availableFacets: null
  },
  emits: ["update-height"],
  setup(__props: any, { emit }: { emit: ({(e: 'update-height'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    visibleFacets: FacetViewObject[],
    facetGroupName: string,

    availableFacets: { [facetId: string] : FacetValueViewObject[] }
}




const facetsToShow = computed<FacetViewObject[]>(() => {
    if (displayShowMoreButton.value) {
        return props.visibleFacets.slice(0, facetCountBeforeShowMore);
    }
    return props.visibleFacets;
});

const facetCountBeforeShowMore: number = 3;
const showMoreFacets = ref<boolean>(false);
const displayShowMoreButton = computed<boolean>(() => props.visibleFacets.length > (facetCountBeforeShowMore + 1) && !showMoreFacets.value);

async function showMore() {
    showMoreFacets.value = true;
    await nextTick();
    emit('update-height');
}

const groupIsDisabled = computed<boolean>(() => {
    for (let i = 0; i < props.visibleFacets.length; i++) {
        const facetId = props.visibleFacets[i].facetId;
        const facet = props.availableFacets[facetId];
        if (facet !== undefined && facet.length > 0) {
            return false;
        }
    }
    return true;
});

return { __sfc: true,props, emit, facetsToShow, facetCountBeforeShowMore, showMoreFacets, displayShowMoreButton, showMore, groupIsDisabled, CategoryProductFacetFilteringDropdown }
}

})